module.exports = __webpack_public_path__ + "img/1457920200.b5b03b31.jpg";